/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      lib util — custom_fields array filtering helpers (by id/name)
 *   extends:   -
 *   template:  none
 *   args:      -
 *   uses:      -
 *   siblings:  sibling utility/models.js, utility/strings.js, utility/ajax.js
 *              (re-exported together via the ../utility.js barrel)
 *   tests:     tests/unit/lib/utility-test.js (module "custom-fields & dates"),
 *              tests/unit/lib/utility-extra-test.js, tests/unit/lib/utility-wave5-test.js
 *
 * @module beebee-base/lib/utility/custom-fields
 * @description Custom fields filtering utilities.
 */

/**
 * Filtra custom fields per lista di ID
 * @param {Array} cfs - Array di custom fields
 * @param {Array<string>} ids - Lista ID da cercare
 * @returns {Array} Custom fields filtrati
 */
function cfFilterIds(cfs, ids) {
  if (!Array.isArray(cfs) || !Array.isArray(ids) || cfs.length === 0) {
    return [];
  }
  return cfs.filter(cf => ids.includes(cf.organization_custom_field?.id));
}

/**
 * Trova un custom field per ID
 * @param {Array} cfs - Array di custom fields
 * @param {string} id - ID da cercare
 * @returns {Object|null} Custom field trovato o null
 */
function cfFilterId(cfs, id) {
  if (!Array.isArray(cfs) || !id || cfs.length === 0) {
    return null;
  }
  return cfs.find(i => i.organization_custom_field?.id === id) ?? null;
}

/**
 * Filtra custom fields per lista di nomi
 * @param {Array} cfs - Array di custom fields
 * @param {Array<string>} names - Lista nomi da cercare
 * @returns {Array|null} Custom fields filtrati
 */
function cfFilterNames(cfs, names) {
  if (!Array.isArray(cfs) || !Array.isArray(names) || cfs.length === 0) {
    // Return [] (not null) to match the sibling cfFilterIds: callers chain
    // array methods (.length/.map) on the result.
    return [];
  }
  return cfs.filter(cf => names.includes(cf.organization_custom_field?.name));
}

/**
 * Trova un custom field per nome
 * @param {Array} cfs - Array di custom fields
 * @param {string} name - Nome da cercare
 * @returns {Object|null} Custom field trovato o null
 */
function cfFilterName(cfs, name) {
  if (!Array.isArray(cfs) || !name || cfs.length === 0) {
    return null;
  }
  return cfs.find(cf => cf.organization_custom_field?.name === name) ?? null;
}

export { cfFilterId, cfFilterIds, cfFilterName, cfFilterNames };
//# sourceMappingURL=custom-fields.js.map
